import script from "./CustomerServiceContactList.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerServiceContactList.vue?vue&type=script&setup=true&lang=js"

import "./CustomerServiceContactList.vue?vue&type=style&index=0&id=d6a01956&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6a01956"]])

export default __exports__